export const componentTypes = {
  LIST_SELECT: 'LIST_SELECT',
  DATE_PICKER: 'DATE_PICKER',
  LOCATION_LOOKUP: 'LOCATION_LOOKUP',
  TYPEAHEAD: 'TYPEAHEAD',
  TAG_SELECTOR: 'TAG_SELECTOR',
  TEXT_INPUT: 'TEXT_INPUT',
  CUSTOM_SELECTION: 'CUSTOM_SELECTION'
};
